<template>
  <el-menu
    default-active="1"
    :collapse="collapsed"
    router
    :default-active="$route.path"
    unique-opened
    collapse-transition>
    <el-submenu
      v-for="menu in allmenu"
      :key="menu.jurId"
      :index="menu.jurTitle"
    >
      <template slot="title">
        <i :class="menu.jurIcon"></i>
        <span>{{ menu.jurTitle }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.children"
          :index="chmenu.jurUrl"
          :key="chmenu.jurId"
          @click="handleClick(menu.jurTitle,chmenu.jurTitle,chmenu.jurUrl)"
        >
          <div class="box_itme" style="display: flex;">
            <div class="" style="width: 50%;text-align: end; margin-left: 10px;"><span class="class_box_itme"></span></div>
            <div>{{ chmenu.jurTitle }}</div>
          </div>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { isReturn } from '@/utils/retnue'
import { getTeachers } from "@/api/fiveClassApi"
export default {
  name: "LeftMenu",
  data() {
    return {
      collapsed: false,
      allmenu: [],
      setIntervalClr:null,
    };
  },
  created() {},
  destroyed(){
    clearInterval(this.setIntervalClr)
  },
  mounted() {

    console.log(`%c
                                                         __----~~~~~~~~~~~------___
                                        .  .   ~~//====......          __--~ ~~
                        -.            \_|//     |||\\  ~~~~~~::::... /~
                     ___-==_       _-~o~  \/    |||  \\            _/~~-
             __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
         _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
       .~       .~       |   \\ -_    /  /-   /   ||      \   /
      /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
      |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
               '         ~-|      /|    |-~\~~       __--~~
                           |-~~-_/ |    |   ~\_   _-~            /\
                                /  \     \__   \/~                \__
                            _--~ _/ | .-~~____--~-/                  ~~==.
                           ((->/~   '.|||' -_|    ~~-/ ,              . _||
                                      -_     ~\      ~~---l__i__i__i--~~_/
                                      _-~-__   ~)  \--______________--~~
                                    //.-~~~-~_--~- |-------~~~~~~~~
                                           //.-~~~--\
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

                                   大火龙🐉            永无BUG
    `,"color: red")



    this.setIntervalClr = setInterval(()=>{
        getTeachers().then(res => {
           isReturn(res.code)
        })
    },20000)

    let arr = JSON.parse(window.localStorage.getItem("jur"))
    let username = window.localStorage.getItem("username")



    this.allmenu = arr.filter((itme)=>{
      return (itme.jurTitle !== "小程序权限" && itme.jurTitle !== "组织架构" && itme.jurTitle !== "通知权限" && itme.jurTitle !== '测试菜单' && itme.jurTitle !== '城市权限')
    })



    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '审批管理员'){
              itme.children.splice(index, 1);
           }
         })
      }
    })


    this.allmenu.forEach((itme)=>{

      if(itme.jurTitle === '系统管理'){
         let isUser = true
         let isRole = true
         itme.children.forEach((itmes,index)=>{
            if (index === 4) {
                isUser = false
            }
            if (index === 5) {
                isRole = false
            }
         })
         window.sessionStorage.setItem('isUser', isUser)
         window.sessionStorage.setItem('isRole', isRole)

      }
    })



    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '用户删除权限'){
              itme.children.splice(index, 1);
           }
         })
      }
    })

    this.allmenu.forEach((itme)=>{
      if(itme.children){
         itme.children.forEach((itmes,index)=>{
           if(itmes.jurTitle === '角色删除权限'){
              itme.children.splice(index, 1);
           }
         })
      }
    })


  },

  methods:{
    handleClick(a,b,c){
      this.$emit("handleClickRouter",a,b,c)
    },
  }

};
</script>
<style scoped lang="less">

.class_box_itme {
  content: "";
  background: #4f9090;
  display: inline-flex;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: 0px;
}

.el-menu-item {
  padding-left: 0px !important;
}

.el-menu-item:hover {
  border-left: 2px solid #409eff;
}
/deep/ .el-submenu__title,
.el-menu-item {
  border-bottom: 1px solid #dbdedfde;
}

/deep/ .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #dbdedfde;
}
/deep/ .el-menu-item-group__title {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/manager/layout/menu.vue